exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#montessori {\n  background-image: url(\"https://res.cloudinary.com/eclimontessori/image/upload/v1571822202/montessori_dtxsek.jpg\"); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./app/pages/montessori/css/index.scss
// module id = 31
// module chunks = 2